import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/pro-light-svg-icons/faFile';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { DocumentType } from '../../../enums/document-type';
import { openPrintModal } from '../../../store/printing/print.actions';
import { printDocument, downloadDocument } from '../../../store/documents/documents.actions';
import { useGetPrintSettingsForDocumentType } from '../../../hooks/use-get-print-settings-for-document-type';
import { DOWNLOAD_PRINT_SETTING_NAME } from '../../../../src/pages/settings/printing/constants';

import style from './forms-column.module.less';

const FormsColumn = ({ fulfillmentIds }) => {
  const dispatch = useDispatch();
  const printSettings = useGetPrintSettingsForDocumentType(DocumentType.OtherForms.printSettingKey);
  const printForm = useCallback(() => {
    if (!printSettings) {
      const url = `${DocumentType.OtherForms.apiDownloadPath}/${fulfillmentIds}`;
      dispatch(openPrintModal(url, DocumentType.OtherForms.identifier, fulfillmentIds));
      return;
    }
    if (printSettings.name === DOWNLOAD_PRINT_SETTING_NAME) {
      dispatch(downloadDocument(DocumentType.OtherForms, fulfillmentIds));
      return;
    }
    dispatch(printDocument(DocumentType.OtherForms, fulfillmentIds, printSettings));
  }, [dispatch, fulfillmentIds, printSettings]);
  return (
    <div className={style['forms-column']}>
      <Tooltip position='bottom'>
        <div onClick={printForm}>
          <FontAwesomeIcon className={style.icon} icon={faFile} />
        </div>
        <TooltipContent>
          <FormattedMessage defaultMessage='Other Forms' description='shipmentsGird.columns.FormsTooltip' id='sGuX+Y' />
        </TooltipContent>
      </Tooltip>
    </div>
  );
};

FormsColumn.propTypes = {
  fulfillmentIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default FormsColumn;
